import { __extends } from "tslib";
import * as React from "react";
import { CircleSliderHelper } from "./helpers/circle-slider-helper";
import { MouseHelper } from "./helpers/mouse-helper";
import { pathGenerator } from "./helpers/path-generator";
var CircleSlider = /** @class */ (function (_super) {
    __extends(CircleSlider, _super);
    function CircleSlider(props) {
        var _this = _super.call(this, props) || this;
        _this.updateAngle = function (angle) {
            _this.circleSliderHelper.updateStepIndexFromAngle(angle);
            var currentStep = _this.circleSliderHelper.getCurrentStep();
            _this.setState({
                angle: angle,
                currentStepValue: currentStep
            });
            _this.props.onChange(currentStep);
        };
        _this.updateSlider = function () {
            var angle = _this.mouseHelper.getNewSliderAngle();
            if (Math.abs(angle - _this.state.angle) < Math.PI) {
                _this.updateAngle(angle);
            }
        };
        _this.updateSliderFromProps = function (valueFromProps) {
            var stepSize = _this.props.stepSize;
            var newValue = Math.round(valueFromProps / stepSize) * stepSize;
            _this.circleSliderHelper.updateStepIndexFromValue(newValue);
            _this.setState({
                angle: _this.circleSliderHelper.getAngle(),
                currentStepValue: newValue
            });
        };
        _this.getCenter = function () {
            return _this.props.size / 2;
        };
        _this.getAngle = function () {
            return _this.state.angle + Math.PI / 2;
        };
        _this.getPointPosition = function () {
            var center = _this.getCenter();
            var angle = _this.getAngle();
            return {
                x: center + _this.radius * Math.cos(angle),
                y: center + _this.radius * Math.sin(angle)
            };
        };
        _this.getStepsArray = function (min, stepSize) {
            var stepArray = [];
            for (var i = 0; i < _this.countSteps; i++) {
                stepArray.push(min + i * stepSize);
            }
            return stepArray;
        };
        _this.getPath = function () {
            var center = _this.getCenter();
            var direction = _this.getAngle() < 1.5 * Math.PI ? 0 : 1;
            var _a = _this.getPointPosition(), x = _a.x, y = _a.y;
            var path = pathGenerator(center, _this.radius, direction, x, y);
            return path;
        };
        _this.handleMouseMove = function (event) {
            event.preventDefault();
            _this.setState({
                isMouseMove: true
            });
            _this.mouseHelper.setPosition(event);
            _this.updateSlider();
        };
        _this.handleMouseUp = function (event) {
            event.preventDefault();
            _this.setState({
                isMouseMove: false
            });
            window.removeEventListener("mousemove", _this.handleMouseMove);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseDown = function (event) {
            if (!_this.props.disabled) {
                event.preventDefault();
                window.addEventListener("mousemove", _this.handleMouseMove);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleTouchMove = function (event) {
            var targetTouches = event.targetTouches;
            var countTouches = targetTouches.length;
            var currentTouch = targetTouches.item(countTouches - 1);
            _this.mouseHelper.setPosition(currentTouch);
            _this.updateSlider();
        };
        _this.handleTouchUp = function () {
            window.removeEventListener("touchmove", _this.handleTouchMove);
            window.removeEventListener("touchend", _this.handleTouchUp);
        };
        _this.handleTouchStart = function () {
            if (!_this.props.disabled) {
                window.addEventListener("touchmove", _this.handleTouchMove);
                window.addEventListener("touchend", _this.handleTouchUp);
            }
        };
        _this.state = {
            angle: 0,
            currentStepValue: 0,
            isMouseMove: false
        };
        var _a = _this.props, min = _a.min, max = _a.max, stepSize = _a.stepSize, value = _a.value, circleWidth = _a.circleWidth, progressWidth = _a.progressWidth, knobRadius = _a.knobRadius;
        _this.maxLineWidth = Math.max(circleWidth, progressWidth);
        _this.radius =
            _this.getCenter() - Math.max(_this.maxLineWidth, knobRadius * 2) / 2;
        _this.countSteps = 1 + (max - min) / stepSize;
        _this.stepsArray = _this.getStepsArray(min, stepSize);
        _this.circleSliderHelper = new CircleSliderHelper(_this.stepsArray, value);
        return _this;
    }
    CircleSlider.prototype.componentDidMount = function () {
        this.mouseHelper = new MouseHelper(this.svg);
        this.setState({
            angle: this.circleSliderHelper.getAngle(),
            currentStepValue: this.circleSliderHelper.getCurrentStep()
        });
    };
    CircleSlider.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.value !== nextProps.value && !this.state.isMouseMove) {
            this.updateSliderFromProps(nextProps.value);
        }
    };
    CircleSlider.prototype.render = function () {
        var _this = this;
        var _a = this.props, size = _a.size, progressColor = _a.progressColor, gradientColorFrom = _a.gradientColorFrom, gradientColorTo = _a.gradientColorTo, knobColor = _a.knobColor, circleColor = _a.circleColor, disabled = _a.disabled, shadow = _a.shadow, circleWidth = _a.circleWidth, progressWidth = _a.progressWidth, knobRadius = _a.knobRadius, showTooltip = _a.showTooltip, showPercentage = _a.showPercentage, tooltipSize = _a.tooltipSize, tooltipColor = _a.tooltipColor;
        var currentStepValue = this.state.currentStepValue;
        var offset = shadow ? "5px" : "0px";
        var _b = this.getPointPosition(), x = _b.x, y = _b.y;
        var center = this.getCenter();
        var isAllGradientColorsAvailable = gradientColorFrom && gradientColorTo;
        return (React.createElement("svg", { ref: function (svg) { return (_this.svg = svg); }, width: "".concat(size, "px"), height: "".concat(size, "px"), viewBox: "0 0 ".concat(size, " ").concat(size), onMouseDown: this.handleMouseDown, onTouchStart: this.handleTouchStart, style: {
                padding: offset,
                boxSizing: "border-box"
            } },
            React.createElement("g", null,
                React.createElement("circle", { style: {
                        strokeWidth: circleWidth,
                        stroke: circleColor,
                        fill: "none"
                    }, r: this.radius, cx: center, cy: center }),
                isAllGradientColorsAvailable && (React.createElement("defs", null,
                    React.createElement("linearGradient", { id: "gradient", x1: "0", x2: "0", y1: "0", y2: "1" },
                        React.createElement("stop", { offset: "0%", stopColor: gradientColorFrom }),
                        React.createElement("stop", { offset: "100%", stopColor: gradientColorTo })))),
                React.createElement("path", { style: {
                        strokeLinecap: "round",
                        strokeWidth: progressWidth,
                        stroke: isAllGradientColorsAvailable
                            ? "url(#gradient)"
                            : progressColor,
                        fill: "none"
                    }, d: this.getPath() }),
                shadow && (React.createElement("filter", { id: "dropShadow", filterUnits: "userSpaceOnUse" },
                    React.createElement("feGaussianBlur", { "in": "SourceAlpha", stdDeviation: "3" }),
                    React.createElement("feOffset", { dx: "2", dy: "2" }),
                    React.createElement("feComponentTransfer", null,
                        React.createElement("feFuncA", { type: "linear", slope: "0.3" })),
                    React.createElement("feMerge", null,
                        React.createElement("feMergeNode", null),
                        React.createElement("feMergeNode", { "in": "SourceGraphic" })))),
                React.createElement("circle", { style: {
                        fill: knobColor,
                        cursor: disabled ? "not-allowed" : "pointer"
                    }, filter: shadow ? "url(#dropShadow)" : "none", r: knobRadius, cx: x, cy: y }),
                showTooltip && (React.createElement("text", { x: size / 2, y: size / 2 + tooltipSize / 3, textAnchor: "middle", fontSize: tooltipSize, fontFamily: "Arial", fill: tooltipColor }, showPercentage
                    ? "".concat(currentStepValue, "%")
                    : currentStepValue)))));
    };
    CircleSlider.defaultProps = {
        circleColor: "#e9eaee",
        size: 180,
        value: 0,
        progressColor: "#007aff",
        knobColor: "#fff",
        circleWidth: 5,
        progressWidth: 20,
        knobRadius: 20,
        stepSize: 1,
        min: 0,
        max: 100,
        disabled: false,
        shadow: true,
        showTooltip: false,
        showPercentage: false,
        tooltipSize: 32,
        tooltipColor: "#333",
        onChange: function () { return ({}); }
    };
    return CircleSlider;
}(React.Component));
export { CircleSlider };
//# sourceMappingURL=index.js.map